import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, ArrowLeft } from "lucide-react";

const ComingSoon = ({ title = "Coming Soon", description, testId = "coming-soon" }) => {
  return (
    <div data-testid={testId} className="min-h-[70vh] flex items-center">
      <div className="hccbt-container py-20">
        <div className="max-w-2xl mx-auto text-center">
          <motion.div
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="w-16 h-16 rounded-full bg-[#87CEEB]/25 mx-auto flex items-center justify-center text-[#0F172A]"
          >
            <Sparkles size={24} />
          </motion.div>

          <motion.span
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="overline mt-6 block"
          >
            {title}
          </motion.span>

          <motion.h1
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.18, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-4xl sm:text-5xl mt-4 text-[#0F172A] leading-tight"
          >
            We're building this for you.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.32 }}
            className="mt-5 text-lg text-[#475569] leading-relaxed"
          >
            {description}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.46 }}
            className="mt-10 flex flex-wrap gap-3 justify-center"
          >
            <Link to="/contact" className="btn-primary" data-testid={`${testId}-stay-updated`}>
              Stay updated
            </Link>
            <Link to="/" className="btn-secondary inline-flex items-center gap-2">
              <ArrowLeft size={16} /> Back to home
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
